<template>
  <div class="text-left">
    <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
      Enter your bank account information for Canada EFT.
    </h4>
    <div class="sm:mt-2 sm:flex sm:gap-6">
      <div class="w-full">
        <form-field
          id="branch"
          label="Branch #"
          :value="branch"
          placeholder="Enter 5-digit branch #"
          :on-input="handleBranchNumber"
          name="branch"
          pattern="\d*"
        />
        <form-field
          label="Bank #"
          :value="bank"
          placeholder="Enter 3 digit bank #"
          :on-input="handleBankNumber"
          :pattern="'number'"
          :show-check="false"
          name="bank_eft"
          :is-valid="!data.errors"
        />
        <form-field
          label="Account #"
          :value="account"
          placeholder="Enter 5-12 digit account #"
          :on-input="handleAccountNumber"
          :pattern="'number'"
          :show-check="false"
          name="account"
          :is-valid="!data.errors"
        />
        <p
          v-if="data.errors"
          class="-mt-3 mb-2 text-3xs text-red-500 sm:hidden"
        >
          Account numbers do not match
        </p>
      </div>
    </div>
    <p
      v-if="data.errors"
      class="-mt-3 hidden text-3xs text-red-500 sm:block"
    >
      Account numbers do not match
    </p>
  </div>
</template>

<script>
import FormField from '../../FormField.vue';
export default {
  name: 'CanadaEft',
  components: {
    'form-field': FormField,
  },
  props: {
    data: Object,
    firstTime: {
      type: [Number, Boolean],
      required: true,
    },
    stepName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      branch: '',
      bank: '',
      account: '',
    };
  },
  computed: {
    isValidForm: function () {
      return (
        this.isValidBranchNumber() &&
        this.isValidBankNumber() &&
        this.isValidAccountNumber()
      );
    },
    newPaymentMethodType() {
      return this.$store.state.payments?.newPaymentMethodType;
    },
  },
  watch: {
    isValidForm: function (isValid) {
      this.$store.commit('toggleDisabledButton', {
        bool: !isValid,
        source: 'Payment-3 CanadaEft #5',
      });
    },
    verify_account_number: function (nv) {
      this.$store.dispatch('payments/updateNestedField', {
        path: 'errors',
        value: nv !== this.account_number,
      });
      if (nv.length < 6)
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Payment-3 CanadaEft #6',
        });
    },
    account_number: function (nv) {
      this.$store.dispatch('payments/updateNestedField', {
        path: 'errors',
        value: nv !== this.verify_account_number,
      });
      if (nv.length < 6)
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Payment-3 CanadaEft #7',
        });
    },
    stepName: function (val) {
      // if (val === "Payment-3" && !this.firstTime) {
      if (val === 'Payment-3' && this.newPaymentMethodType == 'cad_eft') {
        if (
          this.branch?.length > 0 &&
          this.bank?.length > 0 &&
          this.account?.length > 0
        ) {
          this.onUpdate();
        } else {
          this.toggleButton(true);
        }
      }
    },
  },
  mounted() {
    this.$store.commit(
      'addFormDebugMessage',
      'Payment-3 | CanadaEft | CanadaEft mounted'
    );
    if (!this.isValidForm) {
      this.$store.commit('toggleDisabledButton', {
        bool: true,
        source: 'Payment-3 CanadaEft #1',
      });
    } else {
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'Payment-3 CanadaEft #2',
      });
    }
  },
  methods: {
    isNumeric(str) {
      if (typeof str != 'string') return false;
      return !isNaN(str) && !isNaN(parseFloat(str));
    },
    isValidBranchNumber: function () {
      return this.isNumeric(this.branch) && this.branch.length === 5;
    },
    isValidBankNumber: function () {
      return this.isNumeric(this.bank) && this.bank.toString().length === 3;
    },
    isValidAccountNumber: function () {
      return (
        this.isNumeric(this.account) &&
        this.account.length >= 5 &&
        this.account.length <= 12
      );
    },
    handleBranchNumber(e) {
      this.branch = e.target.value;
      if (e.target.value.length < 5)
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Payment-3 CanadaEft #3',
        });
      this.onUpdate();
    },
    handleBankNumber(e) {
      this.bank = e.target.value;
      this.onUpdate();
    },
    handleAccountNumber(e) {
      this.account = e.target.value;
      this.onUpdate();
    },
    onUpdate() {
      let body = {
        is_active: true,
        cad_eft_branch_number: this.branch,
        cad_eft_bank_number: this.bank,
        cad_eft_account_number: this.account,
        is_type: this.$store.state.payments.newPaymentMethodType,
      };
      this.updateOnboardingPacket(body);
    },
    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'Payment-3 CanadaEft #4',
      });
    },
    updateOnboardingPacket(body) {
      this.$store.dispatch('payments/setPaymentBody', {
        payment_method: body,
      });
    },
  },
};
</script>
